<template>
<select @input="onInput($event.target.value)" ref="areaSelector">
  <option value="">選択して下さい</option>
  <option v-for="area in areaList" :selected="area === value">{{ area }}</option>
</select>
</template>

<script>
export default {
  props: ['value'],
  data () {
    return {
      areaList: ['北海道', '東北', '関東', '中部', '近畿', '中国', '四国', '九州', '沖縄']
    }
  },
  methods: {
    onInput (value) {
      this.$refs.areaSelector.value = value
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AreaSelector.vue?750050c0